module.exports = __webpack_public_path__ + "img/odwh3_v2_element_06.a38b8088.png";